export const getSociety = (state) => state.society
export const getSocietyShops = (state) => state.society?.shops || []
export const canCreateShop = (state) => state.canCreateShop
